<template>
    <VideoForumModal :is-from-modal="props.isModal" />
    <OrientationLock v-show="whiteboard.isOpen"></OrientationLock>
    <div class="my-4" v-if="whiteboard.isOpen">
        <div class="relative">
            <LoadBackgroundModal
                @loaded="doSetWhiteboardBackground"
                :sport="sport"
                class="absolute top-12 left-2 z-[2000]"
            ></LoadBackgroundModal>
            <LoadTemplateModal
                class="absolute top-24 left-2 z-[2000]"
                :play-api="playApi"
                :playbook-api="playbookApi"
                :preview-url="previewUrl"
                :whiteboard-api="whiteboardApi"
                @loaded="doSetWhiteboardTemplate"
            >
            </LoadTemplateModal>
            <div class="relative">
                <div class="w-[800px] h-[400px]">
                    <Whiteboard
                        :is-play="true"
                        :whiteboard-api="whiteboardApi"
                        :sport="sport"
                        :team-id="teamIdFromUrl"
                        title=""
                        :play="play"
                        :relative-to-container="true"
                    ></Whiteboard>
                </div>
                <input
                    type="hidden"
                    name="whiteboard_id"
                    :value="whiteboard.id"
                />
                <input
                    type="hidden"
                    name="whiteboard_background"
                    :value="whiteboard.background"
                />
                <input
                    type="hidden"
                    name="whiteboard_data"
                    :value="whiteboard.data"
                />
                <input
                    type="file"
                    name="whiteboard_thumbnail"
                    ref="whiteboardThumbnailFileRef"
                    class="hidden"
                />
            </div>
        </div>
    </div>
    <div class="bg-gray-100 rounded-md">
        <div id="tiptap-container" class="p-6 relative">
            <editor-content :editor="editor" />
            <button
                v-if="!whiteboard.isOpen"
                type="button"
                class="
                    bg-transparent
                    text-sm text-primary
                    font-semibold
                    top-4
                    right-4
                    absolute
                "
                @click="doPrepareWhiteboard()"
            >
                Whiteboard
            </button>
            <button
                v-else
                type="button"
                class="
                    bg-transparent
                    text-sm text-primary
                    font-semibold
                    top-4
                    right-4
                    absolute
                "
                @click="doCloseWhiteboard()"
            >
                Close Whiteboard
            </button>
        </div>
        <div class="bg-gray-100 py-2 px-6 my-6" v-if="firstResolvedLink">
            <div
                class="bg-white rounded-md p-4 shadow max-w-full md:max-w-[50%]"
            >
                <img
                    v-if="firstResolvedLink.image"
                    :src="firstResolvedLink.image"
                    alt="Link image"
                    class="
                        aspect-[2/1]
                        rounded-lg
                        w-full
                        h-auto
                        object-cover
                        mb-2
                    "
                />
                <div class="font-semibold">
                    {{ firstResolvedLink.title }}
                </div>
                <div class="text-xs opacity-50 mt-2 break-words">
                    {{ firstResolvedLink.description }}
                </div>
                <a
                    class="
                        block
                        text-xs
                        opacity-50
                        max-w-[80%]
                        text-ellipsis
                        overflow-hidden
                        mt-2
                        hover:underline
                    "
                    :href="firstResolvedLink.url"
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    {{ firstResolvedLink.url }}
                </a>
            </div>
        </div>
        <div v-if="isResolvingLink" class="flex items-center gap-4 px-6 my-4">
            <simple-loading-circle /> Resolving link...
        </div>
        <div class="py-2 px-4 flex items-center gap-1 w-full" v-if="editor">
            <tiptap-menu-button
                @click="editor.chain().focus().toggleBold().run()"
                :active="editor.isActive('bold')"
                >B
            </tiptap-menu-button>
            <tiptap-menu-button
                @click="editor.chain().focus().toggleItalic().run()"
                :active="editor.isActive('italic')"
                >I
            </tiptap-menu-button>
            <tiptap-menu-button
                @click="editor.chain().focus().toggleStrike().run()"
                :active="editor.isActive('strike')"
                >S
            </tiptap-menu-button>
            <tiptap-menu-button
                @click="editor.chain().focus().toggleCode().run()"
                :active="editor.isActive('code')"
            >
                <ion-icon name="code-slash-outline"></ion-icon>
            </tiptap-menu-button>
            <tiptap-menu-button @click="doPrepareAttachLink()">
                <ion-icon name="link-outline"></ion-icon>
            </tiptap-menu-button>
            <tiptap-menu-button
                @click="doPrepareAttachFile()"
                v-if="!hideAttachments"
            >
                <ion-icon name="attach-outline"></ion-icon>
            </tiptap-menu-button>
            <tiptap-menu-button
                @click="doPrepareVideoModal()"
                v-if="!hideAttachments"
            >
                <img src="/img/video.svg" width="16" />
            </tiptap-menu-button>
            <input
                name="attachment"
                type="file"
                class="hidden"
                ref="inputFileRef"
                @change="doAttachFile()"
            />
            <input
                name="attachment_thumbnail"
                type="file"
                class="hidden"
                ref="inputFileThumbnailRef"
            />
            <input
                name="attachment_type"
                type="hidden"
                :value="attachments.type"
            />

            <input
                name="video_attachment_path"
                type="hidden"
                :value="videoAttachments.path"
                v-if="videoAttachments.name"
            />

            <input
                name="video_attachment_name"
                type="hidden"
                :value="videoAttachments.name"
                v-if="videoAttachments.name"
            />

            <input
                name="video_attachment_thumbnail"
                type="hidden"
                :value="videoAttachments.thumbnail"
                v-if="videoAttachments.name"
            />

            <input
                name="video_attachment_size"
                type="hidden"
                :value="videoAttachments.size"
                v-if="videoAttachments.name"
            />

            <div class="ml-auto" v-if="showSubmit">
                <tiptap-menu-button
                    type="submit"
                    @click.prevent="submit($event)"
                >
                    <ion-icon name="send-outline"></ion-icon>
                </tiptap-menu-button>
            </div>
        </div>
    </div>
    <input v-if="editor" type="hidden" :name="name" :value="json" />
    <input type="hidden" name="meta" :value="metaJson" />
    <ModalCustom
        :is-open="modals.link.isOpen"
        @close="modals.link.isOpen = false"
        title="Attach Link"
    >
        <app-input
            autofocus
            label="Link"
            @keypress.enter="doAttachLink"
            v-model="modals.link.link"
            placeholder="https://clipboardnation.com"
        ></app-input>
        <div class="flex justify-end my-4">
            <app-button
                :disabled="!isLinkValid"
                type="button"
                @click="doAttachLink"
                >Attach
            </app-button>
        </div>
    </ModalCustom>

    <div class="my-4" v-if="videoAttachments.name">
        <h3 class="text-sm font-semibold">Attachments</h3>
        <div class="my-1 flex items-center">
            <img
                v-if="videoAttachments.thumbnail"
                :src="videoAttachments.thumbnail"
                alt="Preview"
                class="w-24 h-24 aspect-square object-cover rounded"
            />
            <ion-icon
                v-else
                class="text-[96px] text-gray-500"
                name="document-attach-outline"
            ></ion-icon>
            <div class="ml-4">
                <div
                    class="text-sm font-semibold truncate break-words break-all"
                >
                    {{ videoAttachments.name ?? "Existing Attachment" }}
                </div>
                <div class="text-xs text-gray-500">
                    ~{{ Math.ceil(videoAttachments.size / 1024) }} KB
                    <div
                        v-if="fileTooLarge()"
                        class="bg-red-100 text-red-900 p-1 rounded"
                    >
                        The file is too large, max is 100MB
                    </div>
                    <div
                        v-if="invalidFileType()"
                        class="bg-red-100 text-red-900 p-1 rounded"
                    >
                        The file type is not allowed
                    </div>
                </div>
                <a
                    class="cursor-pointer text-xs text-red-500 hover:underline"
                    @click="removeAttachment"
                    >Remove Attachment</a
                >
            </div>
        </div>
    </div>

    <div class="my-4" v-if="attachments.file || attachments.preview">
        <h3 class="text-sm font-semibold">Attachments</h3>
        <div class="my-1 flex items-center">
            <img
                v-if="attachments.preview"
                :src="attachments.preview"
                alt="Preview"
                class="w-24 h-24 aspect-square object-cover rounded"
            />
            <ion-icon
                v-else
                class="text-[96px] text-gray-500"
                name="document-attach-outline"
            ></ion-icon>
            <div class="ml-4">
                <div
                    class="text-sm font-semibold truncate break-words break-all"
                >
                    {{ attachments.file?.name ?? "Existing Attachment" }}
                </div>
                <div class="text-xs text-gray-500" v-if="attachments.file">
                    ~{{ Math.ceil(attachments.file?.size / 1024) }} KB
                    <div
                        v-if="fileTooLarge()"
                        class="bg-red-100 text-red-900 p-1 rounded"
                    >
                        The file is too large, max is 100MB
                    </div>
                    <div
                        v-if="invalidFileType()"
                        class="bg-red-100 text-red-900 p-1 rounded"
                    >
                        The file type is not allowed
                    </div>
                </div>
                <a
                    class="cursor-pointer text-xs text-red-500 hover:underline"
                    @click="removeAttachment"
                    >Remove Attachment</a
                >
            </div>
        </div>
    </div>
</template>

<script setup>
import { EditorContent, useEditor } from "@tiptap/vue-3";
import StarterKit from "@tiptap/starter-kit";
import { Placeholder } from "@tiptap/extension-placeholder";
import TiptapMenuButton from "./tiptap/tiptap-menu-button.vue";
import { Link } from "@tiptap/extension-link";
import { computed, nextTick, onMounted, reactive, ref, watch } from "vue";
import ModalCustom from "../ModalCustom.vue";
import AppInput from "../AppInput.vue";
import AppButton from "../AppButton.vue";
import { Mention } from "@tiptap/extension-mention";
import { mentionSuggestion } from "./tiptap/suggestion";
import LoadBackgroundModal from "../LoadBackgroundModal.vue";
import { truncateJson } from "../../utils/play";
import LoadTemplateModal from "../LoadTemplateModal.vue";
import { LinkPortalExtension } from "./tiptap/link-portal";
import SimpleLoadingCircle from "../SimpleLoadingCircle.vue";
import OrientationLock from "../OrientationLock.vue";
import emitter from "tiny-emitter/instance";

const props = defineProps({
    placeholder: String,
    name: String,
    whiteboardUrl: String,
    context: Object,
    showSubmit: {
        default: true,
        type: Boolean,
    },
    isEdit: {
        default: false,
        type: Boolean,
    },

    previewUrl: String,
    playbookApi: String,
    playApi: String,
    whiteboardApi: String,
    sport: String,
    isModal: Boolean,
    hideAttachments: Boolean,
});

const emit = defineEmits(["submit"]);

const modals = reactive({
    link: {
        isOpen: false,
        link: "",
    },
    mention: {
        isOpen: false,
        query: "",
        list: [],
        selected: null,
    },
});

const attachments = reactive({
    link: null,
    file: null,
    preview: null,
    type: null,
});

const videoAttachments = reactive({
    name: null,
    path: null,
    thumbnail: null,
    type: null,
});

const inputFileRef = ref(null);
const inputFileThumbnailRef = ref(null);
const iframeRef = ref(null);
const whiteboardThumbnailFileRef = ref(null);

const isLinkValid = computed(() => {
    try {
        let targetLink = modals.link.link;
        if (!targetLink.startsWith("http")) {
            targetLink = "https://" + targetLink;
        }
        const url = new URL(targetLink);
        return url.protocol === "http:" || url.protocol === "https:";
    } catch (e) {
        return false;
    }
});

const json = ref(null);
const detectedLinks = ref([]);
const firstResolvedLink = ref(null);
const isResolvingLink = ref(false);
const resolvedList = ref([]);

const teamIdFromUrl = new URLSearchParams(window.location.search).get("teamId");

const fileTooLarge = () => {
    if (attachments.file) {
        // max 10mb if teamId is not set on query params
        const qs = new URLSearchParams(window.location.search);
        const hasTeamId = qs.has("teamId");
        if (!hasTeamId && attachments.file.size > 1000000000) {
            return true;
        }

        if (hasTeamId && attachments.file.size > 25000000) {
            return true;
        }
    }
};

const allowedTypes = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/bmp",
    "image/webp",
    "video/mp4",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/pdf",
    "video/quicktime",
];
const invalidFileType = () => {
    if (attachments.file) {
        if (!allowedTypes.includes(attachments.file.type)) {
            return true;
        }
    }
    return false;
};

const getVideoThumbnail = async (file) => {
    const cover = await getVideoCover(file);
    const reader = new FileReader();
    reader.onload = (e) => {
        attachments.preview = e.target.result;
    };
    reader.readAsDataURL(cover);

    var filecover = new File([cover], cover.name);
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(filecover);
    inputFileThumbnailRef.value.files = dataTransfer.files;
};

function getVideoCover(file, seekTo = 0.0) {
    return new Promise((resolve, reject) => {
        // load the file to a video player
        const videoPlayer = document.createElement("video");
        videoPlayer.setAttribute("src", URL.createObjectURL(file));
        videoPlayer.load();
        videoPlayer.addEventListener("error", (ex) => {
            reject("error when loading video file", ex);
        });
        // load metadata of the video to get video duration and dimensions
        videoPlayer.addEventListener("loadedmetadata", () => {
            // seek to user defined timestamp (in seconds) if possible
            if (videoPlayer.duration < seekTo) {
                reject("video is too short.");
                return;
            }
            // delay seeking or else 'seeked' event won't fire on Safari
            setTimeout(() => {
                videoPlayer.currentTime = seekTo;
            }, 200);
            // extract video thumbnail once seeking is complete
            videoPlayer.addEventListener("seeked", () => {
                console.log("video is now paused at %ss.", seekTo);
                // define a canvas to have the same dimension as the video
                const canvas = document.createElement("canvas");
                canvas.width = videoPlayer.videoWidth;
                canvas.height = videoPlayer.videoHeight;
                // draw the video frame to canvas
                const ctx = canvas.getContext("2d");
                ctx.drawImage(videoPlayer, 0, 0, canvas.width, canvas.height);
                // return the canvas image as a blob
                ctx.canvas.toBlob(
                    (blob) => {
                        resolve(blob);
                    },
                    "image/jpeg",
                    0.75 /* quality */
                );
            });
        });
    });
}

watch(
    () => detectedLinks.value,
    (links) => {
        const first = links[0];
        if (
            resolvedList.value.includes(first) &&
            firstResolvedLink.value?.url === first
        ) {
            return;
        }
        resolvedList.value.push(first);
        if (first) {
            isResolvingLink.value = true;
            axios
                .post("/utils/link-portal", { url: first })
                .then((response) => {
                    firstResolvedLink.value = {
                        ...response.data,
                        url: first,
                    };
                })
                .catch((e) => {
                    console.error(e);
                    firstResolvedLink.value = null;
                })
                .finally(() => {
                    isResolvingLink.value = false;
                });
        } else {
            firstResolvedLink.value = null;
        }
    }
);

const play = computed(() => {
    return {
        play_json: props.context?.play_json || [],
    };
});

const metaJson = computed(() => {
    return JSON.stringify({
        firstResolvedLink: firstResolvedLink.value,
    });
});

const editor = useEditor({
    editable: true,
    extensions: [
        StarterKit,
        Placeholder.configure({
            placeholder: props.placeholder,
        }),
        Link.configure({
            openOnClick: false,
            HTMLAttributes: {
                class: "text-blue-500 hover:underline",
            },
        }),
        Mention.configure({
            suggestion: mentionSuggestion,
            HTMLAttributes: {
                class: "font-semibold mx-2 text-blue-800 bg-blue-100 rounded-md px-2 py-1",
            },
            renderLabel: (props) => {
                return `@${props.node.attrs.id.name}`;
            },
        }),
        LinkPortalExtension.configure({
            onDetectLinks: (links) => {
                detectedLinks.value = links;
            },
        }),
    ],
    editorProps: {
        attributes: {
            class: "outline-none",
        },
    },
});

const whiteboard = reactive({
    isOpen: false,
    id: crypto.randomUUID(),
    background: null,
    data: [],
});

function doSetWhiteboardBackground(background) {
    if (background.image !== "none") {
        whiteboard.background = background.image;
    } else {
        whiteboard.background = null;
    }

    emitter.emit("wb-change-background", background.image);
}

function doSetWhiteboardTemplate(json) {
    if (json.data?.background) {
        doSetWhiteboardBackground({
            image: json.data.background,
        });
    }

    emitter.emit("wb-load-play", { play_json: json.data.playJson });
}

function doCloseWhiteboard() {
    whiteboard.isOpen = false;
    whiteboard.background = null;
    whiteboard.data = [];
    whiteboard.id = crypto.randomUUID();
}
function doPrepareWhiteboard() {
    whiteboard.isOpen = true;
    if (props.context?.background) {
        setTimeout(() => {
            doSetWhiteboardBackground({ image: props.context.background });
        }, 1000);
    }
}

function doPrepareAttachFile() {
    inputFileRef.value.click();
}

function doPrepareVideoModal() {
    emitter.emit("tiptap-video-modal", true);
}
emitter.on("attach-forum-video", (video) => {
    videoAttachments.thumbnail = video.thumbnail;
    videoAttachments.name = video.title;
    videoAttachments.path = video.url;
    videoAttachments.size = video.size;
});

function doAttachFile() {
    if (inputFileRef.value.files.length === 0) {
        return;
    }
    const file = inputFileRef.value.files[0];
    attachments.file = file;

    // if image
    if (file.type.startsWith("image")) {
        const reader = new FileReader();
        reader.onload = (e) => {
            attachments.preview = e.target.result;
        };
        reader.readAsDataURL(file);
        attachments.type = "image";
    }

    if (file.type.startsWith("video")) {
        getVideoThumbnail(attachments.file);
        attachments.type = "video";
    }
}

function removeAttachment() {
    attachments.file = null;
    attachments.preview = null;
    attachments.type = null;
    inputFileRef.value.value = null;

    videoAttachments.name = null;
    videoAttachments.thumbnail = null;
    videoAttachments.size = null;
}

function doPrepareAttachLink() {
    const attr = editor.value.getAttributes(Link);
    if (attr?.href) {
        // Get attribute of current mark
        modals.link.isOpen = true;
        modals.link.link = attr.href;
    } else {
        modals.link.isOpen = true;
        modals.link.link = "";
    }
}

function doAttachLink() {
    if (!isLinkValid.value) {
        return;
    }
    let targetLink = modals.link.link;
    if (!targetLink.startsWith("http")) {
        targetLink = "https://" + targetLink;
    }
    if (editor.value.state.selection.empty) {
        const attr = editor.value.getAttributes(Link);
        if (attr?.href) {
            editor.value.chain().focus().setLink(targetLink).run();
        } else {
            editor.value
                .chain()
                .focus()
                .insertContent({
                    type: "text",
                    marks: [
                        {
                            type: "link",
                            attrs: {
                                href: targetLink,
                                target: "_blank",
                                class: "text-blue-500 hover:underline",
                            },
                        },
                    ],
                    text: targetLink,
                })
                .run();
        }
    } else {
        editor.value.chain().focus().setLink(targetLink).run();
    }

    modals.link.isOpen = false;
}

function getWhiteboardData() {
    emitter.emit("getBufferData");
    return new Promise((resolve, reject) => {
        emitter.once("getBufferDataReply", function (data) {
            resolve(data);
        });
    });
}

async function submit($event) {
    if (fileTooLarge()) {
        return;
    }
    if (invalidFileType()) {
        return;
    }
    json.value = JSON.stringify(editor.value.getJSON());
    if (whiteboard.isOpen) {
        const whiteboardData = await getWhiteboardData();
        whiteboard.data = JSON.stringify(whiteboardData.data);

        const file = new File([whiteboardData.image], "thumbnail.png", {
            type: "image/png",
            lastModified: new Date().getTime(),
        });

        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        whiteboardThumbnailFileRef.value.files = dataTransfer.files;
        nextTick(() => {
            $event.target.form.submit();
            emit("submit");
        });
    } else {
        nextTick(() => {
            $event.target.form.submit();
            emit("submit");
        });
    }
}

function getText() {
    return editor.value.getText();
}

onMounted(() => {
    if (props.isEdit) {
        try {
            const asJson = JSON.parse(props.context.content);
            editor.value.commands.setContent(asJson);
        } catch (e) {
            editor.value.commands.setContent(props.context.content);
        }
        if (props.context.play_json) {
            doPrepareWhiteboard();
        }
        if (props.context.attachment) {
            attachments.link = props.context.attachmentUrl;
            attachments.preview = props.context.attachmentThumbnailUrl;
        }
    }
});

defineExpose({
    submit,
    getText,
});
</script>

<style>
.ProseMirror p.is-editor-empty:first-child::before {
    content: attr(data-placeholder);
    float: left;
    color: #adb5bd;
    pointer-events: none;
    height: 0;
}

.ProseMirror code {
    background: #d0dae0;
    color: #1e4964;
    padding: 4px 6px;
    border-radius: 4px;
    font-size: 0.75em;
    font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier,
        monospace;
}
#tiptap-container {
    width: 100%;
    word-wrap: break-word;
    overflow-wrap: break-word;
}
</style>
